<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <service-header
        @export-pdf="exportPDF"
        @export-csv="exportCSV"
        @print-table="printTable"
        @refresh="refreshList"
      ></service-header>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" />
                <a href="javascript:void(0);" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
            <div class="search-path">
              <a
                class="btn btn-filter"
                id="filter_search"
                v-on:click="filter = !filter"
                :class="{ setclose: filter }"
              >
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span
                  ><img src="@/assets/img/icons/closes.svg" alt="img"
                /></span>
              </a>
            </div>
            <div class="form-sort">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select
                :options="Sortby"
                id="sortby"
                placeholder="Par Date"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card mb-0"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Service</label>
                        <div class="input-with-icon">
                          <vue-feather type="box" class="info-img"></vue-feather>
                          <vue-select
                            :options="ChooseFilter"
                            id="choosefilter"
                            placeholder="Choisir un service"
                            v-model="activeFilters.name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Catégorie</label>
                        <div class="input-with-icon">
                          <vue-feather type="stop-circle" class="info-img"></vue-feather>
                          <vue-select
                            :options="CategroyFilter"
                            id="categroyfilter"
                            placeholder="Choisir une Catégorie"
                            v-model="activeFilters.category"
                          />
                        </div>
                      </div>
                    </div>

                    
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks my-4">
                        <a class="btn btn-filters ms-auto">
                          <i data-feather="search" class="feather-search"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive product-list">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredData.length ? filteredData : data"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'statut_achat'">
                  <div>
                    <span
                      :class="
                        record.statut_achat
                          ? 'badge badge-linesuccess'
                          : 'badge badge-linedanger'
                      "
                      >{{ record.statut_achat ? "Actif" : "Inactif" }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'statut_vente'">
                  <div>
                    <span
                      :class="
                        record.statut_vente
                          ? 'badge badge-linesuccess'
                          : 'badge badge-linedanger'
                      "
                      >{{ record.statut_vente ? "Actif" : "Inactif" }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'prix_achat'">
                  <span class="price-pill price-pill-purchase">
                    {{ formatCurrency(record.prix_achat) }}
                  </span>
                </template>
                <template v-if="column.key === 'prix_vente'">
                  <span class="price-pill price-pill-sale">
                    {{ formatCurrency(record.prix_vente) }}
                  </span>
                </template>
                <template v-if="column.key === 'market_price_average'">
                  <span v-if="record.market_price_loading" class="text-muted small">Recherche...</span>
                  <span v-else-if="record.market_price_average != null" class="price-pill price-pill-market">
                    {{ formatCurrency(record.market_price_average) }}
                  </span>
                  <span v-else-if="record.market_price_message" class="text-muted small">
                    {{ record.market_price_message }}
                  </span>
                  <span v-else>—</span>
                </template>
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <router-link
                        v-if="$can('services.update')"
                        class="me-2 p-2"
                        to="/produits/modification-service"
                        @click="selectService(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </router-link>
                      <a
                        v-can="'services.delete'"
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <vue-feather
                          type="trash-2"
                          class="trash-2"
                        ></vue-feather>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <product-list-modal></product-list-modal>
</template>
<script>
import {
  getServicesData,
  deleteService,
  getCategoriesData,
  searchServiceMarketPrice,
  isMarketPriceSearchLimitError,
} from "@/services/productsService";
import serviceHeader from "./service-header.vue";
import { toast } from "vue3-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl } from "@/services/companyService";

const columns = [
  {
    title: "Réf",
    dataIndex: "reference_service",
    sorter: {
      compare: (a, b) => String(a.reference_service || "").localeCompare(String(b.reference_service || "")),
    },
  },
  {
    title: "Service",
    dataIndex: "nom",
    sorter: {
      compare: (a, b) => String(a.nom || "").localeCompare(String(b.nom || "")),
    },
  },

  {
    title: "Description",
    dataIndex: "description",
    sorter: {
      compare: (a, b) => String(a.description || "").localeCompare(String(b.description || "")),
    },
  },
  {
    title: "Catégorie",
    dataIndex: "categorie_nom",
    sorter: {
      compare: (a, b) => String(a.categorie_nom || "").localeCompare(String(b.categorie_nom || "")),
    },
  },
  {
    title: "Durér de jours",
    dataIndex: "duree_jours",
    sorter: {
      compare: (a, b) => (Number(a.duree_jours) || 0) - (Number(b.duree_jours) || 0),
    },
  },
  {
    title: "Prix d'Achat",
    dataIndex: "prix_achat",
    key: "prix_achat",
    sorter: {
      compare: (a, b) => (Number(a.prix_achat) || 0) - (Number(b.prix_achat) || 0),
    },
  },
  {
    title: "Prix de Vente",
    dataIndex: "prix_vente",
    key: "prix_vente",
    sorter: {
      compare: (a, b) => (Number(a.prix_vente) || 0) - (Number(b.prix_vente) || 0),
    },
  },
  {
    title: "Prix moyen marché",
    dataIndex: "market_price_average",
    key: "market_price_average",
    sorter: {
      compare: (a, b) =>
        (Number(a.market_price_average) || 0) - (Number(b.market_price_average) || 0),
    },
  },
  {
    title: "Status d'Achat",
    dataIndex: "statut_achat",
    key: "statut_achat",
    sorter: {
      compare: (a, b) => (a.statut_achat === b.statut_achat ? 0 : a.statut_achat ? -1 : 1),
    },
  },
  {
    title: "Status de Vente",
    dataIndex: "statut_vente",
    key: "statut_vente",
    sorter: {
      compare: (a, b) => (a.statut_vente === b.statut_vente ? 0 : a.statut_vente ? -1 : 1),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
import Swal from "sweetalert2";
export default {
  components: {
    serviceHeader,
  },
  data() {
    return {
      filter: false,
      Sortby: ["Par Date", "14 09 23", "11 09 23"],
      ChooseFilter: ["Choisir un service"],
      CategroyFilter: ["Toutes les catégories"],
      data,
      columns,
      selectedProduct: {},
      filteredData: [],
      activeFilters: {
        name: null,
        category: null,
      },
      marketPriceCache: {},
    };
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === "") return "—";
      const number = Number(value);
      if (Number.isNaN(number)) return value;
      return number.toLocaleString("fr-FR", {
        style: "currency",
        currency: "MAD",
        minimumFractionDigits: 2,
      });
    },
    getPricedMarketResults(payload) {
      const results = Array.isArray(payload?.results) ? payload.results : [];
      return results
        .map((result) => Number(result.price))
        .filter((price) => Number.isFinite(price) && price > 0);
    },
    calculateMarketAverage(payload) {
      const prices = this.getPricedMarketResults(payload);
      if (!prices.length) {
        return {
          average: null,
          count: 0,
        };
      }
      const total = prices.reduce((sum, price) => sum + price, 0);
      return {
        average: Math.round((total / prices.length) * 100) / 100,
        count: prices.length,
      };
    },
    getMarketPriceCacheKey(service) {
      return service && service.id != null
        ? `market_price_service_${service.id}`
        : null;
    },
    readSavedMarketPrice(service) {
      const key = this.getMarketPriceCacheKey(service);
      if (!key) return null;
      try {
        const saved = JSON.parse(localStorage.getItem(key) || "null");
        return saved && typeof saved === "object" ? saved : null;
      } catch (e) {
        return null;
      }
    },
    saveMarketPrice(service, payload) {
      const key = this.getMarketPriceCacheKey(service);
      if (!key) return;
      try {
        localStorage.setItem(
          key,
          JSON.stringify({
            average: payload.average,
            count: payload.count,
            message: payload.message,
            savedAt: new Date().toISOString(),
          })
        );
      } catch (e) {
        // ignore storage quota/private mode errors
      }
    },
    setServiceMarketPrice(service, patch) {
      if (!service) return;
      Object.assign(service, patch);
      if (service.id != null) {
        this.marketPriceCache = {
          ...this.marketPriceCache,
          [service.id]: {
            average: service.market_price_average,
            count: service.market_price_count,
            message: service.market_price_message,
          },
        };
      }
    },
    async loadMarketPriceAverage(service) {
      if (!service || service.id == null) return;

      const cached = this.marketPriceCache[service.id];
      if (cached) {
        this.setServiceMarketPrice(service, {
          market_price_average: cached.average,
          market_price_count: cached.count,
          market_price_message: cached.message,
          market_price_loading: false,
        });
        return;
      }

      const saved = this.readSavedMarketPrice(service);
      if (saved) {
        this.setServiceMarketPrice(service, {
          market_price_average: saved.average,
          market_price_count: saved.count,
          market_price_message: saved.message,
          market_price_loading: false,
        });
        return;
      }

      if (!service.reference_service) {
        this.setServiceMarketPrice(service, {
          market_price_average: null,
          market_price_count: 0,
          market_price_message: "Réf. manquante",
          market_price_loading: false,
        });
        return;
      }

      const salePrice = Number(service.prix_vente);
      if (!Number.isFinite(salePrice) || salePrice < 0) {
        this.setServiceMarketPrice(service, {
          market_price_average: null,
          market_price_count: 0,
          market_price_message: "Prix vente manquant",
          market_price_loading: false,
        });
        return;
      }

      service.market_price_loading = true;
      service.market_price_message = "";

      try {
        const result = await searchServiceMarketPrice({
          reference_service: service.reference_service,
          nom: service.nom,
          prix_vente: salePrice,
        });
        const average = this.calculateMarketAverage(result);
        const payload = {
          average: average.average,
          count: average.count,
          message: average.count > 0 ? "" : "Aucun prix exploitable",
        };
        this.saveMarketPrice(service, payload);
        this.setServiceMarketPrice(service, {
          market_price_average: payload.average,
          market_price_count: payload.count,
          market_price_message: payload.message,
          market_price_loading: false,
        });
      } catch (error) {
        console.error(error);
        const message = isMarketPriceSearchLimitError(error)
          ? error.message
          : "Indisponible";
        this.setServiceMarketPrice(service, {
          market_price_average: null,
          market_price_count: 0,
          market_price_message: message,
          market_price_loading: false,
        });
      }
    },
    async loadMarketPriceAverages() {
      const services = this.data.filter((service) => service && service.id != null);
      const concurrency = 3;

      for (let index = 0; index < services.length; index += concurrency) {
        const batch = services.slice(index, index + concurrency);
        await Promise.all(batch.map((service) => this.loadMarketPriceAverage(service)));
      }
    },
    async loadCompanyLogoDataUrl() {
      try {
        return await getCompanyLogoDataUrl('logo');
      } catch (e) {
        return null;
      }
    },
    refreshList() {
      this.getServicesData().then(() => this.loadMarketPriceAverages());
    },
    exportCSV() {
      const rows = this.data;
      const headers = [
        "Réf",
        "Service",
        "Description",
        "Catégorie",
        "Durée (jours)",
        "Prix d'Achat",
        "Prix de Vente",
        "Prix moyen marché",
        "Achat",
        "Vente",
      ];
      const csv = [
        headers.join(","),
        ...rows.map((r) =>
          [
            r.reference_service || `SRV-${r.id}`,
            r.nom || "",
            r.description || "",
            r.categorie_nom || "",
            r.duree_jours != null ? r.duree_jours : "",
            r.prix_achat != null ? r.prix_achat : "",
            r.prix_vente != null ? r.prix_vente : "",
            r.market_price_average != null ? r.market_price_average : "",
            r.statut_achat ? "Actif" : "Inactif",
            r.statut_vente ? "Actif" : "Inactif",
          ]
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(",")
        ),
      ].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `services_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async exportPDF() {
      try {
        const rows = this.data;
        if (!rows.length) return;

        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
        const dataUrl = await this.loadCompanyLogoDataUrl();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const headerHeight = 26;
        const margin = 12;

        const drawHeader = () => {
          if (!dataUrl) return;
          const logoW = 42, logoH = 16;
          const x = (pageWidth - logoW) / 2;
          const y = 8;
          try {
            const fmt = dataUrl.startsWith('data:image/png') ? 'PNG' : 'JPEG';
            doc.addImage(dataUrl, fmt, x, y, logoW, logoH);
          } catch (_) { /* ignore image draw errors */ }
        };

        const body = rows.map((r) => [
          r.reference_service || `SRV-${r.id}`,
          r.nom || '-',
          r.description || '-',
          r.categorie_nom || '-',
          r.duree_jours != null ? String(r.duree_jours) : '-',
          r.prix_achat != null ? Number(r.prix_achat).toFixed(2) + ' MAD' : '-',
          r.prix_vente != null ? Number(r.prix_vente).toFixed(2) + ' MAD' : '-',
          r.market_price_average != null ? Number(r.market_price_average).toFixed(2) + ' MAD' : '-',
          r.statut_achat ? '✓ Actif' : '✗ Inactif',
          r.statut_vente ? '✓ Actif' : '✗ Inactif',
        ]);

        autoTable(doc, {
          startY: headerHeight,
          head: [[
            'Référence', 'Service', 'Description', 'Catégorie', 'Durée (jours)', "Prix d'Achat", 'Prix de Vente', 'Prix moyen marché', 'Achat', 'Vente'
          ]],
          body,
          headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
          styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
          columnStyles: {
            0: { cellWidth: 20, fontStyle: 'bold' },
            1: { cellWidth: 30 },
            2: { cellWidth: 40 },
            3: { cellWidth: 28 },
            4: { cellWidth: 22, halign: 'center' },
            5: { cellWidth: 24, halign: 'right' },
            6: { cellWidth: 24, halign: 'right' },
            7: { cellWidth: 28, halign: 'right' },
            8: { cellWidth: 18, halign: 'center' },
            9: { cellWidth: 18, halign: 'center' },
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          didDrawPage: () => {
            drawHeader();
            const pageCount = doc.internal.getNumberOfPages();
            const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
            doc.setFontSize(9);
            doc.setTextColor(120);
            doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
            doc.setTextColor(0);
          },
          margin: { left: margin, right: margin, top: headerHeight + 4, bottom: 15 },
        });

        doc.save(`services_${new Date().toISOString().slice(0,10)}.pdf`);
      } catch (err) {
        console.error('Error exporting services PDF', err);
      }
    },
    printTable() {
      const rows = this.data;
      const win = window.open('', '_blank');
      const html = `
        <html><head><title>Liste des Services</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Services</h3>
        <table>
          <thead>
            <tr>
              <th>Réf</th><th>Service</th><th>Description</th><th>Catégorie</th><th>Durée (jours)</th><th>Prix d'Achat</th><th>Prix de Vente</th><th>Prix moyen marché</th><th>Achat</th><th>Vente</th>
            </tr>
          </thead>
          <tbody>
            ${rows.map((r) => `
              <tr>
                <td>${r.reference_service || `SRV-${r.id}`}</td>
                <td>${r.nom || ''}</td>
                <td>${r.description || ''}</td>
                <td>${r.categorie_nom || ''}</td>
                <td>${r.duree_jours != null ? r.duree_jours : ''}</td>
                <td>${r.prix_achat != null ? r.prix_achat : ''}</td>
                <td>${r.prix_vente != null ? r.prix_vente : ''}</td>
                <td>${r.market_price_average != null ? r.market_price_average : ''}</td>
                <td>${r.statut_achat ? 'Actif' : 'Inactif'}</td>
                <td>${r.statut_vente ? 'Actif' : 'Inactif'}</td>
              </tr>`).join('')}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce service ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        cancelButtonText: "Annuler",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteService(id);
            if (localStorage.getItem("services") != null) {
              let services = JSON.parse(localStorage.getItem("services"));
              services = services.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(services);
              localStorage.setItem("services", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Le Service a été supprimer",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getServicesData() {
      this.data = [];
      if (localStorage.getItem("services") != null) {
        const data = JSON.parse(localStorage.getItem("services"));
        data.map((m) => {
          this.data.push({
            id: m.id,
            societe_id: m.societe_id,
            nom: m.nom,
            description: m.description,
            duree_jours: m.duree_jours,
            prix_vente_minimum: m.prix_vente_minimum,
            prix_achat: m.prix_achat,
            prix_vente: m.prix_vente,
            market_price_average: null,
            market_price_count: 0,
            market_price_message: "",
            market_price_loading: false,
            reference_service: m.reference_service,
            statut_achat: m.statut_achat,
            statut_vente: m.statut_vente,
            taux_taxe: m.taux_taxe,
            categorie_id: m.categorie.id,
            categorie_nom: m.categorie.name,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getServicesData();
          data.map((m) => {
            this.data.push({
              id: m.id,
              societe_id: m.societe_id,
              nom: m.nom,
              description: m.description,
              duree_jours: m.duree_jours,
              prix_vente_minimum: m.prix_vente_minimum,
              prix_achat: m.prix_achat,
              prix_vente: m.prix_vente,
              market_price_average: null,
              market_price_count: 0,
              market_price_message: "",
              market_price_loading: false,
              reference_service: m.reference_service,
              statut_achat: m.statut_achat,
              statut_vente: m.statut_vente,
              taux_taxe: m.taux_taxe,
              categorie_id: m.categorie.id,
              categorie_nom: m.categorie.name,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
        }
      }
      // Initialize filters and filteredData
      this.filteredData = [...this.data];
      this.updateFilterOptions();
    },
    async loadCategories() {
      try {
        const cats = await getCategoriesData();
        const names = Array.from(new Set((cats || []).map((c) => c.name).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'fr'));
        this.CategroyFilter = ["Toutes les catégories", ...names];
      } catch (e) {
        // keep default
      }
    },
    updateFilterOptions() {
      const names = Array.from(new Set(this.data.map((s) => s.nom).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'fr'));
      this.ChooseFilter = ["Tous les services", ...names];
    },
    applyFilters() {
      const name = this.activeFilters.name && this.activeFilters.name !== 'Tous les services' ? this.activeFilters.name : null;
      const category = this.activeFilters.category && this.activeFilters.category !== 'Toutes les catégories' ? this.activeFilters.category : null;
      this.filteredData = this.data.filter((s) => {
        const okName = name ? s.nom === name : true;
        const okCat = category ? s.categorie_nom === category : true;
        return okName && okCat;
      });
    },

    selectService(item) {
      this.selectedService = item;
      localStorage.setItem("service", JSON.stringify(this.selectedService));
    },
  },
  mounted() {
    this.getServicesData().then(() => this.loadMarketPriceAverages());
    this.loadCategories();
  },
  watch: {
    'activeFilters.name'() {
      this.applyFilters();
    },
    'activeFilters.category'() {
      this.applyFilters();
    },
  },
};
</script>
<style scoped>
.price-pill {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 92px;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.price-pill-purchase {
  color: #9a3412;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.price-pill-sale {
  color: #166534;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.price-pill-market {
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}
</style>
